import React from 'react';
import PropTypes from 'prop-types';

import { Flex } from '@ubisend/pulse-components';
import { Markdown as PulseMarkdown } from '@ubisend/pulse-markdown';

import Bubble from './Bubble';

const Markdown = ({ content, direction, ...props }) => {
  const markdownClass = `
    message-type-markdown
    ${direction === 'sentMessage' ? 'message-type-markdown-left' : 'message-type-markdown-right'}
  `.trim();

  return (
    <Flex fat right={direction === 'recievedMessage'}>
      <Bubble direction={direction} {...props}>
        <div className={markdownClass}>
          <PulseMarkdown isBubble>{content.text}</PulseMarkdown>
        </div>
      </Bubble>
    </Flex>
  );
};

Markdown.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.string.isRequired,
  }),
  direction: Bubble.propTypes.direction,
};

export default Markdown;